var music = [
    {
        title: "Schumann - Sehr Rasch (Stücke II) from Bunte Blätter",
        subtitle: "Op. 99, No. 2",
        short_description: "<p>For personal reference/learning purposes. Not for commercial or even public use!<br> [<b>FREE MIDI</b>]</p>",
        url: "https://sonive.com/static/schumann op 99 no 2.mid"
    },
    {
        title: "Trill Waltz (Waltz in G major); Easy Version",
        subtitle: "Op. 1b, No. 11",
        short_description: "<p>A waltz of many trills. <br><i><b>Easy Version</b></i><br> [<b>FREE PDF</b>]</p>",
        url: "https://sonive.com/static/waltz no 11 op 1b free sheet music.pdf",
        bookUrl: "/music/12-Grand-Waltzes"
    },
    {
        title: "Trill Waltz (Waltz in G major); Normal (Hard) Version",
        subtitle: "Op. 1, No. 11",
        short_description: "<p>A waltz of many trills. <br><i><b>Normal (Hard) Version</b></i><br> [<b>FREE PDF</b>]</p>",
        url: "https://sonive.com/static/waltz no 11 op 1 free sheet music.pdf",
        bookUrl: "/music/24-Waltzes"
    },
    {
        title: "Prelude in E flat major",
        subtitle: "Op. ???",
        short_description: "<p>The one-handed prelude. <br><i><b style='color: red;'>Warning:</b></i> a draft, expect errors! <br> [<b>FREE PDF</b>]</p>",
        url: "https://sonive.com/static/prelude e flat major free sheet music.pdf",
    },
    {
        title: "Waltz No. 4 in G minor",
        subtitle: "Op. 1, No. 4",
        short_description: "<p>An intricate waltz for solo piano. <br><i><b style='color: red;'>Warning:</b></i> difficult! <br> [<b>FREE PDF</b>]</p>",
        url: "https://sonive.com/static/Waltz No. 4 free sheet music.pdf",
        bookUrl: "/music/24-Waltzes"
    },
    {
        title: "Waltz No. 5 in B minor",
        subtitle: "Op. 1, No. 5",
        short_description: "<p>A powerful waltz for solo piano. <br><i><b style='color: red;'>Warning:</b></i> difficult! <br> [<b>FREE PDF</b>]</p>",
        url: "https://sonive.com/static/Waltz No. 5 free sheet music.pdf",
        bookUrl: "/music/24-Waltzes"
    }
]

export const freeMusic = music